import {dispatch} from 'od-modules/secure_store/store';
import {SET_MEMBERSHIP_INFO} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('membershipServiceFormatter')('membership-info');
    },
    getMethod() {
        return 'GET';
    },
    requestSuccess(data) {
        Odigeo.trigger('membershipInfoOk', data);
        if (data && Odigeo.Utils.getCurrentPath().indexOf('/secure') !== -1) {
            dispatch({type: SET_MEMBERSHIP_INFO, entry: data});
        }
        return data;
    },
    requestError(error) {
        Odigeo.trigger('membershipInfoFail', error);
    },
};
